import type { InjectionKey, ComputedRef } from 'vue';

export const WNM_FORM_ID = 'worry-no-more--form' as const;

export const WNM_SLIDEOUT_DEFAULTS = {
  id: 'worry-no-more--slideout-form',
  title: 'Worry-free coverage for your purchase',
} as const;

export type ProtectionPlanType = {
  id: number;
  name: string;
  description: string;
  displayType: string;
  wnmUnitFee: number;
  recommended: boolean;
  priority: number;
  feeDepartment: string;
  feeClass: string;
};

type WMNType = {
  isWnmVisible: ComputedRef<boolean>;
  isWnmFlyoutEligible: ComputedRef<boolean>;
  protectionPlans: ComputedRef<ProtectionPlanType[] | null>;
  selectedPlan: ComputedRef<ProtectionPlanType | null>;
  defaultPlanId: ComputedRef<number>;
  isProductBigTicket: ComputedRef<boolean>;
  setPlanIdEntryByUpc: () => void;
};

export const PDP_WNM_REPOSITORY: InjectionKey<WMNType> = Symbol('PDP_WNM_REPOSITORY');
